import { initialProps } from '@utils/initial'
import { routes } from '@group-devs/yfp7-global-modules/data/lcw'
import Head from 'next/head'
import Error from '../404'
import { LcwLayout, IndexHeader, WhatYouWillLearn, ScientificBreakthrough, SuccessStoryBecky,
    WhyCarbs, RevealMostDiets, HelpfulResources, SuccessStoryAaron, TakeAPeek7BS, About, DiscoverHow  } from '@components/Block'
import { useAvatar } from '../../hooks/useAvatar'

export async function getServerSideProps({req, res, query}) {
    return {
        props: await initialProps(req, res, query, routes.sbs)
    }
}

const SevenBS = (props) => {

    if (typeof props.err !== "undefined")
        return <Error statusCode={props.err.code} />

    const { avatar } = useAvatar(props.auth, props.site);

    return (
        <LcwLayout global={props}
            ogurl="/7big-secrets-to-180" 
            ogsiteName="The 7 Big Secrets to Losing Weight"
            ogsiteDesc="Special report reveals how some of Hollywood's biggest stars get in shape and look their best within weeks." 
            ogImg="../images/7bs/img-7-big-secrets-to-weight-loss-share01.jpg"
            ogIcon="../images/7bs/img-favicon-7bs01.ico"
        >
            <IndexHeader global={props}/>
            <WhatYouWillLearn/>
            <ScientificBreakthrough/>
            <SuccessStoryBecky/>
            <WhyCarbs/>
            <RevealMostDiets/>
            <HelpfulResources/>
            <SuccessStoryAaron/>
            <TakeAPeek7BS/>
            <About global={props} avatar={avatar} />
            <DiscoverHow global={props}/>
        </LcwLayout>
    )
}

export default SevenBS